import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Select, MenuItem, FormControl, } from "@mui/material";
import "./MapSelect.css";
import { useEffect, useState } from "react";
import { getMaps, changeMap } from "../../store/MapDisplayThunks";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ClickAwayListener from '@mui/material/ClickAwayListener';

const MapSelect = () => {
  const { mapConfig, maps } = useSelector((state) => state.MapDisplay);
  const { localAvatar } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const initRef = useRef(false);
  const anchorRef = useRef(null);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showContent, setShowContent] = useState(false);

  const handleChangeMap = (mapId) => {
    setIsMenuOpen(false);
    /*setIsDropdownOpen(false);*/
    dispatch(changeMap({ body: { mapId: mapId } }));
  }

  useEffect(() => {
    let timeout;
    if (isMenuOpen) {
      timeout = setTimeout(() => {
        setShowContent(true);
      }, 250);
    } else {
      setShowContent(false);
    }
    return () => clearTimeout(timeout);
  }, [isMenuOpen]);

  useEffect(() => {
    if (!initRef.current) {
      initRef.current = true;
      dispatch(getMaps({ params: [{ user_id: localAvatar.id }] }));
      return;
    }
  }, [dispatch, localAvatar.id]);

  const currentMap = maps.find((map) => map.id === mapConfig.mapId);

  const handleButtonHover = (e) => {
    if (!isDropdownOpen) setIsMenuOpen((prev) => !prev);
    e.stopPropagation();
  };
  const handleButtonLeave = (e) => {
    if (!isDropdownOpen) setIsMenuOpen(false);
    e.stopPropagation();
  };

  const handleArrowClick = (e) => {
    setIsDropdownOpen((prev) => !prev);
    e.stopPropagation();
  };

  function useMobile() {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 480);

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 700);
      };

      window.addEventListener('resize', handleResize);

      // Nettoyage
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    return isMobile;
  }

  const isMobile = useMobile();



  return (
    <ClickAwayListener
      onClickAway={() => {
        setIsDropdownOpen(false);
        setIsMenuOpen(false);
      }}>
      <div className="map-select-wrapper"
        onClick={handleArrowClick}>
        <div
          className={`custom-map-button ${isMenuOpen ? 'open-state' : ''}`}
          onMouseEnter={!isMobile ? handleButtonHover : undefined}
          onMouseLeave={!isMobile ? handleButtonLeave : undefined}
          ref={anchorRef}
        >
          <img
            onClick={isMobile ? handleButtonHover : undefined}
            className="custom-map-button-icon"
            src="/Aifel.svg"
            alt="people map"
          />

          <div className="custom-map-button-text-container"
            style={{ display: !showContent ? 'none' : '' }} >
            {showContent && (
              <span className="custom-map-button-text">
                {currentMap?.name}
              </span>
            )}

            <KeyboardArrowUpIcon
              className={`custom-map-button-arrow ${isMenuOpen ? 'open' : ''} ${isDropdownOpen ? 'rotate' : ''}`}
              sx={{
                display: maps.length > 1 ? 'block' : 'none', // hide icon if only 1 map
              }}
            />

          </div>

        </div>

        <div className={`custom-menu ${isDropdownOpen && maps.length > 1 ? 'open' : ''}`}>
          {maps
            .filter((map) => map.id !== mapConfig.mapId)
            .map((map) => (
              <div
                className="custom-menu-item"
                key={map.id}
                value={map.id}
                onClick={() => handleChangeMap(map.id)}
              >
                <div className="map-thumbnail-wrapper">
                  <img
                    src={map.thumbnail_url}
                    alt={map?.map_tenants[0]?.name}
                    className="map-thumbnail"
                  />
                  {/*  <span className="map-name-tooltip">{map.name}</span> */}
                </div>
                {map?.map_tenants[0]?.name}
              </div>
            )
            )}
        </div>

      </div>
    </ClickAwayListener>

  );
};

export default MapSelect;